import { If, onCleanup, onMount } from 'cdui-js';
import { goBackByBrowser, routeReplace } from '../../../lib/browser';
import { initRNBridge, registerRNHandler } from '../../../lib/rnBridge';
import { bootDepositApp, isFundHideNav } from '../deposit/h5-deposit/appBridge';
import { IconBack } from './icons';
import { listUrl } from './shared';

type ShellProps = {
  title: string;
  right?: any;
  /** 自定义返回；与 onBack 二选一（兼容旧写法） */
  backFn?: () => void;
  onBack?: () => void;
  footer?: any;
  overlay?: any;
  children?: any;
};

const isPendingListPath = () =>
  typeof window !== 'undefined' && /\/pending-list\/?$/.test(window.location.pathname);

export const BankShell = (props: ShellProps) => {
  const resolveBackFn = () => props.backFn || props.onBack;

  const handleBack = (source: string) => {
    const custom = resolveBackFn();
    console.log('[bank-shell] handleBack', {
      source,
      href: typeof window !== 'undefined' ? window.location.href : '',
      pathname: typeof window !== 'undefined' ? window.location.pathname : '',
      historyLength: typeof window !== 'undefined' ? window.history.length : -1,
      hasCustomBack: typeof custom === 'function',
      isPendingList: isPendingListPath(),
      hasRN: typeof window !== 'undefined' && !!(window as any).ReactNativeWebView,
    });
    if (typeof custom === 'function') {
      custom();
      return;
    }
    // 添加列表兜底：勿 goBackByBrowser（WebView 常误退到 / 或关页）
    if (isPendingListPath()) {
      const target = listUrl();
      console.log('[bank-shell] pending-list fallback routeReplace', { target });
      window.setTimeout(() => routeReplace(target), 0);
      return;
    }
    goBackByBrowser();
  };

  onMount(() => {
    void bootDepositApp().catch(() => {});
    initRNBridge();
    /** App 顶栏 / 物理返回：hideNav=1 时 H5 无返回钮，必须吃 APP_TO_WEB_GoBack */
    const unreg = registerRNHandler((msg) => {
      if (msg?.type !== 'APP_TO_WEB_GoBack') return;
      console.log('[bank-shell] APP_TO_WEB_GoBack', {
        href: typeof window !== 'undefined' ? window.location.href : '',
        historyLength: typeof window !== 'undefined' ? window.history.length : -1,
        timestamp: msg.timestamp,
      });
      handleBack('APP_TO_WEB_GoBack');
    });
    onCleanup(() => unreg());
  });

  const hideNav = isFundHideNav();

  return (
    <div class="bank-accounts-h5">
      <If when={!hideNav}>
        <div class="nav">
          <button type="button" class="nav-back" onclick={() => handleBack('nav-button')}>
            <IconBack />
          </button>
          <div class="nav-title">{props.title}</div>
          <div class="nav-right">{props.right}</div>
        </div>
      </If>
      <div class="bank-scroll">{props.children}</div>
      {props.footer ? <div class="footer">{props.footer}</div> : null}
      {props.overlay}
    </div>
  );
};
